import { MasterDataApiService } from 'Services/ApiServices';
import { shouldFetchData } from 'Helpers/ReduxHelper';
import { normalizeApiResponse } from 'Helpers/ApiHelpers';
import F2WCustomLogger from 'Services/F2WCustomLogger';
import {
  GET_JOBFAMILIES_SUCCESS,
  GET_JOBTITLES_SUCCESS,
  GET_POSITION_TYPES_SUCCESS,
} from 'Constants/MasterDataConstants';

export function getJobFamilies() {
  const getJobFamiliesSuccess = (jobFamilies) => {
    return {
      type: GET_JOBFAMILIES_SUCCESS,
      data: { jobFamilies },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!shouldFetchData(masterData?.jobFamilies)) return;

    try {
      const response = await MasterDataApiService.getJobFamilies();
      const { data: responseData } = normalizeApiResponse(response);
      const data = responseData?.masterDataList || [];
      dispatch(getJobFamiliesSuccess(data));
    } catch (error) {
      F2WCustomLogger.error('Error fetching job families', error, { action: 'getJobFamilies' });
      dispatch(getJobFamiliesSuccess([]));
    }
  };
}

export function getJobTitles() {
  const getJobTitlesSuccess = (jobTitles) => {
    return {
      type: GET_JOBTITLES_SUCCESS,
      data: { jobTitles },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!shouldFetchData(masterData?.jobTitles)) return;

    try {
      const response = await MasterDataApiService.getJobTitles();
      const { data: responseData } = normalizeApiResponse(response);
      const data = responseData?.masterDataList || [];
      const additionalTitles = [
        { label: 'CT 01 - TBFT (TUI Blue for Two)', value: 'CT 01 - TBFT (TUI Blue for Two)' },
        { label: 'CT 02 - TBFF (TUI Blue for Families)', value: 'CT 02 - TBFF (TUI Blue for Families)' },
        { label: 'CT 03 - TBSEN (TUI Blue Sensatori)', value: 'CT 03 - TBSEN (TUI Blue Sensatori)' },
        { label: 'CT 04 - TBFA (TUI Blue for All)', value: 'CT 04 - TBFA (TUI Blue for All)' },
        { label: 'CT 05 - TKC (TUI Kids Club)', value: 'CT 05 - TKC (TUI Kids Club)' },
        { label: 'CT 06 - TUI SUN (TUI Suneo)', value: 'CT 06 - TUI SUN (TUI Suneo)' },
        { label: 'CT 07 - HV (Holiday Village)', value: 'CT 07 - HV (Holiday Village)' },
        { label: 'CT 08 - Shared Costs', value: 'CT 08 - Shared Costs' },
      ];
      dispatch(getJobTitlesSuccess([...data, ...additionalTitles]));
    } catch (error) {
      F2WCustomLogger.error('Error fetching job titles', error, { action: 'getJobTitles' });
      dispatch(getJobTitlesSuccess([]));
    }
  };
}

export function getPositionTypes() {
  const getPositionTypesSuccess = (positionTypes) => {
    return {
      type: GET_POSITION_TYPES_SUCCESS,
      data: { positionTypes },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!shouldFetchData(masterData?.positionTypes)) return;

    try {
      const response = await MasterDataApiService.getPositionTypes();
      const { data: responseData } = normalizeApiResponse(response);
      const data = responseData?.masterDataList || [];
      dispatch(getPositionTypesSuccess(data));
    } catch (error) {
      F2WCustomLogger.error('Error fetching position types', error, { action: 'getPositionTypes' });
      dispatch(getPositionTypesSuccess([]));
    }
  };
}
